import {toast} from 'react-toastify';

/**
 * Client-side reaction to 402 (Payment Required) responses produced by the
 * subscription-enforcement middleware. The response body is a problem-details
 * object with a `code` of either:
 *  - 'subscription_required' — the account is billing-only; send the user to
 *    the billing page (at most once per page load).
 *  - 'subscription_readonly' — writes are blocked; show a toast (rate-limited)
 *    and let the normal error flow run so optimistic updates revert.
 */

export const BILLING_ROUTE = '/settings/billing';

const READONLY_TOAST_INTERVAL_MS = 5000;

let redirectedToBilling = false;
let lastReadOnlyToastAt = 0;

export const handlePaymentRequired = (errorData: unknown): void => {
    if (typeof errorData !== 'object' || errorData === null) return;

    const code = (errorData as Record<string, unknown>).code;

    if (code === 'subscription_required') {
        if (redirectedToBilling) return;
        redirectedToBilling = true;
        window.location.assign(BILLING_ROUTE);
        return;
    }

    if (code === 'subscription_readonly') {
        const now = Date.now();
        if (now - lastReadOnlyToastAt < READONLY_TOAST_INTERVAL_MS) return;
        lastReadOnlyToastAt = now;
        toast.error(
            'Your subscription is read-only. Changes are disabled until billing is resolved.'
        );
    }
};
